import pathfinder from '@fiverr-private/pathfinder';

const getSubCategoryUrl = (categorySlug, subCategorySlug, params) => (
    pathfinder(
        'short_category_sub_category',
        {category_id: categorySlug, id: subCategorySlug},
        {query: params}
    )
);

export default getSubCategoryUrl;
